import { apiClient } from '@/shared/lib/api-client';
import type {
  ClubPurchaseOrderStatusResponse,
  ActivateClubPromoCodeBody,
  CreateClubPurchaseOrderBody,
  CreateClubPurchaseOrderResponse,
  PromoActivationPreview,
} from '@bookclub/shared';

export async function createClubPurchaseOrder(
  clubReference: string,
  body: CreateClubPurchaseOrderBody,
): Promise<CreateClubPurchaseOrderResponse> {
  return apiClient.post(`payments/clubs/${clubReference}/orders`, { json: body }).json<CreateClubPurchaseOrderResponse>();
}

export async function activateClubPromoCode(
  clubReference: string,
  body: ActivateClubPromoCodeBody,
): Promise<PromoActivationPreview> {
  return apiClient
    .post(`payments/clubs/${clubReference}/promo-code/activate`, { json: body })
    .json<PromoActivationPreview>();
}

export async function fetchClubPurchaseOrderStatus(
  orderId: string,
): Promise<ClubPurchaseOrderStatusResponse> {
  return apiClient.get(`payments/orders/${orderId}`).json<ClubPurchaseOrderStatusResponse>();
}

export async function fetchClubPurchaseOrderStatusByInvoiceId(
  invoiceId: string,
): Promise<ClubPurchaseOrderStatusResponse> {
  return apiClient
    .get(`payments/robokassa/orders/by-invoice/${invoiceId}`)
    .json<ClubPurchaseOrderStatusResponse>();
}
